// extracted by mini-css-extract-plugin
module.exports = {"button":"AppBtn_button_3p-nx"};